import { KeyboardEvent } from 'react';

import { Card, CardBody, CardFooter, CardHeader, CardTitle } from '@progress/kendo-react-layout';
import { Button } from '@progress/kendo-react-buttons';

import { KWELLO_ICON, KwelloSvgIcon, getComplexIconRaw } from '../../icon/KwelloSvgIcon';
import { useAppSelector } from '../../../../common/hooks/redux';
import {
  selectCitationsOrder,
  selectTargetCitation,
  setTargetCitation,
} from '../../../../common/store/slices/elsie-ai.slice';

import { DATE_FORMAT } from '../../../constants';
import { Link } from 'react-router-dom';

import { SurveyCitation } from 'common/models/elsie-ai.model';

import { useDispatch } from 'react-redux';
import { formatAppDate } from '../../../hooks/utils';
interface WidgetAiCitationsProps {
  onClose?: () => void;
  citations?: SurveyCitation[];
}

export default function WidgetAiCitations({ onClose, citations }: WidgetAiCitationsProps) {
  const dispatch = useDispatch();
  const targetCitation = useAppSelector(selectTargetCitation);
  const citationsOrder = useAppSelector(selectCitationsOrder);

  const removeTargetCitation = () => {
    dispatch(setTargetCitation({ targetCitation: undefined }));
  };

  const onCopy = (text: string) => {
    void navigator.clipboard.writeText(text);
  };

  return (
    <Card className="widget-ai-chat-citations-container">
      <CardHeader>
        <CardTitle>
          {!targetCitation && (
            <span className="citations-count-text">[{citations?.length ?? 0}] Citations</span>
          )}
          {targetCitation && (
            <Button themeColor="light" size="small" onClick={removeTargetCitation}>
              View All Citations
            </Button>
          )}
        </CardTitle>
        {onClose && (
          <div
            role="button"
            tabIndex={0}
            className="flyout-panel-close"
            onClick={onClose}
            onKeyUp={(event: KeyboardEvent<HTMLDivElement>) => {
              if (event.key === 'Enter') onClose();
            }}
          >
            <KwelloSvgIcon icon={KWELLO_ICON.X_ICON} />
          </div>
        )}
      </CardHeader>
      <CardBody>
        {citations?.map((citation) => {
          const copyText = `
Question
${citation.question}
Response Detail
${citation.responseDetail}
Answer
${citation.answer}
Survey
${citation.survey}
          `;

          return (
            <div className="widget-ai-chat-citations-citation" key={citation.responseId}>
              <div className="widget-ai-chat-citations-citation-info">
                <div className="widget-ai-chat-citations-citation-info-date">
                  <KwelloSvgIcon icon={KWELLO_ICON.CALENDAR_ICON} />
                  {citation.date && <span>{formatAppDate(citation.date, DATE_FORMAT)}</span>}
                </div>
                <div className="widget-ai-chat-citations-citation-info-owner">
                  <KwelloSvgIcon icon={KWELLO_ICON.USER_ICON} />
                  <span>{citation.fieldTeam}</span>
                </div>
              </div>

              <div className="widget-ai-chat-citations-citation-patient">
                [{citationsOrder.get(String(citation.responseId)) ?? '-'}] {citation.profile}
              </div>

              <Card>
                <CardBody className="widget-ai-chat-citations-citation-details">
                  <p>Question</p>
                  <p>{citation.question}</p>
                  <p>Response Detail</p>
                  <p>{citation.responseDetail}</p>
                  <p>Answer</p>
                  <p>{citation.answer}</p>
                  <p>Survey</p>
                  <p>{citation.survey}</p>
                </CardBody>

                <CardFooter>
                  <Button
                    className="widget-ai-secondary-button"
                    svgIcon={getComplexIconRaw(KWELLO_ICON.COPY_ICON)}
                    themeColor="light"
                    size="small"
                    onClick={() => onCopy(copyText)}
                  >
                    Copy
                  </Button>

                  {citation.surveyTargetLink && (
                    <Button
                      svgIcon={getComplexIconRaw(KWELLO_ICON.VIEW_SOURCE_ICON)}
                      fillMode="link"
                      size="small"
                    >
                      <Link target="_blank" to={citation.surveyTargetLink}>
                        View Source
                      </Link>
                    </Button>
                  )}
                </CardFooter>
              </Card>
            </div>
          );
        })}
      </CardBody>
    </Card>
  );
}
